module.exports = __webpack_public_path__ + "img/secban.b062ff5b.jpg";